import axios from "axios";


export async function consoleLogMst(error) {
    console.error(error && error.message ? error.message : error);
}


export function getBookingRequestMsg() {
    const filDropOffDate = localStorage.getItem('filDropOffDate');
    const filDropOffTime = localStorage.getItem('filDropOffTime');
    const filPickUpDate = localStorage.getItem('filPickUpDate');
    const filPickUpTime = localStorage.getItem('filPickUpTime');
    const forMessage = localStorage.getItem('forMessage');
    if (!filPickUpDate) {
      return '';
    }
    return `${forMessage} from Date: ${formatDateVerbose(filPickUpDate)} and time: ${filPickUpTime}, Return Date: ${formatDateVerbose(filDropOffDate)} and time: ${filDropOffTime}`;
  }

export function setBodyStyle(styles = {}) {
  Object.entries(styles).forEach(([key, value]) => {
    document.body.style[key] = value;
  });
}

// commons functions
export const S3CDNURL = process.env.REACT_APP_S3_URL;
export const CurrencySymbol = process.env.REACT_APP_CURRENY_SYMBOL;

export const ApplicationName = "Namo Cars";

function gettimeinampm(date) {
    let hours = date.getHours();
    let minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'pm' : 'am';
    hours %= 12;
    if (hours === 0) {
        hours = 12;
    }
    // hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? `0${minutes}` : minutes;
    // const strTime = hours + ':' + minutes + ' ' + ampm;
    return `${hours}:${minutes}${ampm}`;
}

const AllMonthsName = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
];

export function showfulldatetime(datetime) {
    const tmp = new Date(datetime);
    return `${tmp.getDate()} ${AllMonthsName[tmp.getMonth()]
        },${tmp.getUTCFullYear()} ${gettimeinampm(tmp)}`;
}

export function showBookingStatusLabel(status) {
  const statusMap = {
    1: "Upcoming",       // New Created
    2: "Inprogress",     // Car Allotted
    3: "Cancelled",
    5: "Completed",
  };

  const labelValue = statusMap[Number(status)] || "Upcoming";

  const badgeClass = 
    labelValue === "Upcoming"
      ? "badge badge-light-secondary"
      : labelValue === "Inprogress"
        ? "badge badge-light-warning"
        : labelValue === "Cancelled"
          ? "badge badge-light-danger"
          : labelValue === "Completed"
            ? "badge badge-light-success"
            : "";

  return { labelValue, badgeClass };
  // return <span className={badgeClass}>{label}</span>;
}


export function formatTimeVerbose(timeStr) {
  // return timeStr;
  if (!timeStr) return "";

  const [hours, minutes] = timeStr.split(":").map(Number);

  const period = hours >= 12 ? "PM" : "AM";
  const hour12 = hours % 12 || 12;
  let temp = `${hour12}:${minutes} ${period}`;
  try {
    temp = `${hour12}:${minutes.toString().padStart(2, "0")} ${period}`;
  } catch(e) {
    consoleLogMst(e, "Helper: formatTimeVerbose");
  }
  return temp;
}


export function formatDateVerbose(dateStr) {

  if (!dateStr) return ""; // blank or null → return empty string

  const date = new Date(dateStr);
  if (isNaN(date)) return ""; // invalid date format

  // const date = new Date(dateStr);

  const day = date.getDate();
  const month = date.toLocaleString("default", { month: "long" }); // "August"
  const year = date.getFullYear();
  const weekday = date.toLocaleString("default", { weekday: "long" }); // "Saturday"

  // Get ordinal suffix: st, nd, rd, th
  const getOrdinal = (n) => {
    if (n > 3 && n < 21) return "th";
    switch (n % 10) {
      case 1: return "st";
      case 2: return "nd";
      case 3: return "rd";
      default: return "th";
    }
  };

  return `${day}${getOrdinal(day)} ${month}, ${year} (${weekday})`;
}

export function getTodayDate() {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, '0'); // months are 0-indexed
  const day = String(today.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function getAfterDayDate(afterDay = 1) {
  const today = new Date();
  today.setDate(today.getDate() + afterDay); // ✅ add days
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, '0'); // months are 0-indexed
  const day = String(today.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`; // YYYY-MM-DD
}

export function defaultPickUpDate() {
    let tempDate = localStorage.getItem('filPickUpDate');
    if (!tempDate) {
      tempDate = getTodayDate();
      localStorage.setItem('filPickUpDate', tempDate);
    }
    return tempDate;
}

export function defaultDropOffDateOld() {
    let tempDate = localStorage.getItem('filDropOffDate');
    if (!tempDate) {
      tempDate = getTodayDate();
      localStorage.setItem('filDropOffDate', tempDate);
    }
    return tempDate;
}

export function defaultDropOffDate() {
  let tempDate = localStorage.getItem('filDropOffDate');

  if (!tempDate) {
    const date = new Date();
    date.setHours(date.getHours() + 24); // add 24 hours

    tempDate = date.toISOString().split('T')[0]; // YYYY-MM-DD
    localStorage.setItem('filDropOffDate', tempDate);
  }

  return tempDate;
}


export function defaultPickUpTime() {
    let tempTime = localStorage.getItem('filPickUpTime');
    if (!tempTime) {
      tempTime = getHourAfter(2);
      localStorage.setItem('filPickUpTime', tempTime);
    }
    return tempTime;
}

export function defaultDropOffTime() {
    let tempTime = localStorage.getItem('filDropOffTime');
    if (!tempTime) {
      tempTime = getHourAfter(26);
      localStorage.setItem('filDropOffTime', tempTime);
    }
    return tempTime;
}

export function triggerDatePicker(inputPicker) {
    try {
        inputPicker.current?.showPicker?.();
    } catch(err) {
        console.log('Picker not allowed yet:', err.message);
    }
}

export const timeOptions = [
  { value: "05:00", label: "Select Time" },
  { value: "05:30", label: "05:30 AM" },
  { value: "06:00", label: "06 AM" },
  { value: "06:30", label: "06:30 AM" },
  { value: "07:00", label: "07 AM" },
  { value: "07:30", label: "07:30 AM" },
  { value: "08:00", label: "08 AM" },
  { value: "08:30", label: "08:30 AM" },
  { value: "09:00", label: "09 AM" },
  { value: "09:30", label: "09:30 AM" },
  { value: "10:00", label: "10 AM" },
  { value: "10:30", label: "10:30 AM" },
  { value: "11:00", label: "11 AM" },
  { value: "11:30", label: "11:30 AM" },
  { value: "12:00", label: "12 PM" },
  { value: "12:30", label: "12:30 PM" },
  { value: "13:00", label: "01 PM" },
  { value: "13:30", label: "01:30 PM" },
  { value: "14:00", label: "02 PM" },
  { value: "14:30", label: "02:30 PM" },
  { value: "15:00", label: "03 PM" },
  { value: "15:30", label: "03:30 PM" },
  { value: "16:00", label: "04 PM" },
  { value: "16:30", label: "04:30 PM" },
  { value: "17:00", label: "05 PM" },
  { value: "17:30", label: "05:30 PM" },
  { value: "18:00", label: "06 PM" },
  { value: "18:30", label: "06:30 PM" },
  { value: "19:00", label: "07 PM" },
  { value: "19:30", label: "07:30 PM" },
  { value: "20:00", label: "08 PM" },
  { value: "20:30", label: "08:30 PM" },
  { value: "21:00", label: "09 PM" },
  { value: "21:30", label: "09:30 PM" },
  { value: "22:00", label: "10 PM" },
  { value: "22:30", label: "10:30 PM" },
  { value: "23:00", label: "11:00 PM" }
];

export function getHourAfter(hour = 1) {
  if (!hour) {
    return "07:00 am";
  }
  const now = new Date();
  now.setHours(now.getHours() + hour);

  let hours = String(now.getHours()).padStart(2, '0');
  // const minutes = String(now.getMinutes()).padStart(2, '0');
  if (Number(hours) >= 0 && Number(hours) < 5) {
    hours = '07';
  }
  return `${hours}:00`;
}

export const getRandomInt = (min, max) => {
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

export function getPackegValue(carsPackages, pkgID, field) {
    const item = carsPackages.find(pkg => pkg._id === pkgID);
    return item && item[field] ? item[field] : 0;
}

export function getDrivingLimit(carsPackages, pkgID, field, hours, formated = false) {
    let item = carsPackages.find(pkg => pkg._id === pkgID);
    item = item && item[field] ? item[field] : 0;
    if (formated) {
        item = Number(item) * hours;
        return Number(item) === 0 ? "Unlimited" : number_format(item, 0, '.', ',');    
    }
    return Number(item) === 0 ? "Unlimited" : Number(item) * hours;
}

export function number_format(number, decimals = 0, dec_point = '.', thousands_sep = ',') {
  const rounded = Number(number).toFixed(decimals);

  const parts = rounded.split('.');
  const integerPart = parts[0];
  const decimalPart = parts[1] || '';

  const withSeparators = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, thousands_sep);

  return decimals > 0 ? `${withSeparators}${dec_point}${decimalPart}` : withSeparators;
}

export function calculatePackageAmount(carPackageValue, hours, formated) {
    console.log(carPackageValue);
    console.log(hours);
    let hourlyRate = 0;
    if (Number(hours) > 12) {
        hourlyRate = (Number(hours) - 12) * Number(carPackageValue.hourlyRate);
    }
    const totalRate = Number(carPackageValue.baseRate) + hourlyRate;
    if (formated) {
        return number_format(totalRate, 0, '.', ',');  
    }
    return totalRate;
}

export const calculateHourDifference = (
  startDateStr,
  startTime,
  endDateStr,
  endTime,
  roundType = 'ceil'
) => {
  // Create Date objects
  const startDate = new Date(startDateStr);
  const endDate = new Date(endDateStr);

  // Validate
  if (isNaN(startDate) || isNaN(endDate)) {
    console.error("Invalid date provided");
    return 0;
  }

  // Combine date + time
  const [startHours, startMinutes] = startTime.split(":").map(Number);
  const [endHours, endMinutes] = endTime.split(":").map(Number);

  startDate.setHours(startHours, startMinutes, 0, 0);
  endDate.setHours(endHours, endMinutes, 0, 0);

  // Calculate difference (milliseconds → hours)
  const diffMs = endDate - startDate;
  const diffHours = diffMs / (1000 * 60 * 60);

  console.log("Raw hour difference:", diffHours);

  // Handle rounding type
  switch (roundType) {
    case 'floor':
      return Math.floor(diffHours);
    case 'ceil':
      // Ensure minimum of 12 hours if that's intended
      return Math.ceil(diffHours) > 12 ? Math.ceil(diffHours) : 12;
    case 'round':
      return Math.round(diffHours);
    default:
      return diffHours; // return float value
  }
};

export const isValidPickup = (pickUpDate, pickUpTime) => {
  const [hours, minutes] = pickUpTime.split(":").map(Number);

  let finalPickup;

  // If pickUpDate is already a Date object
  if (pickUpDate instanceof Date) {
    finalPickup = new Date(pickUpDate);
  } else {
    // If pickUpDate is a string like "2025-11-27"
    finalPickup = new Date(pickUpDate);
  }

  finalPickup.setHours(hours);
  finalPickup.setMinutes(minutes);
  finalPickup.setSeconds(0);

  const now = new Date();

  return finalPickup > now;
};


export function ShowFullDateTime(isoDate) {
    const date = new Date(isoDate);

    const formattedDate = date.toLocaleDateString("en-GB", {
        day: "numeric",
        month: "long",
        year: "numeric",
    });

    const formattedTime = date.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
    });

    return `${formattedDate} (${formattedTime})`;
}

export function showTitleMaster(idToFind, array) {
    let theTtle = "NA"
    try {
        const titles = array.find(item => item._id === idToFind);
        theTtle = titles && titles.title ? titles.title : 'NA';
    } catch(e) {
        consoleLogMst(e, 'showTitleMaster');
        theTtle = "NA";
    }
    return theTtle;
}

export const generateSlug = (title) => {
  return title
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, '') // remove non-word characters
    .replace(/\s+/g, '-')     // replace spaces with hyphens
    .replace(/-+/g, '-');     // collapse multiple hyphens
};

export function formatedDateTime(dateString) {
  const date = new Date(dateString);

  const day = date.getDate();
  const month = date.toLocaleString('default', { month: 'long' });
  const year = date.getFullYear();

  const suffix = (n) => {
    if (n > 3 && n < 21) return 'th';
    switch (n % 10) {
      case 1: return 'st';
      case 2: return 'nd';
      case 3: return 'rd';
      default: return 'th';
    }
  };

  const formattedTime = date.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  }).toLowerCase();

  return `${day}${suffix(day)} ${month}, ${year} (${formattedTime})`;
}

export async function uploadFileAPI(file, uploadType) {
	let returnData = { status: 0, message: 'Something went wrong, Please try again later.', file: 0 };
	if (!file) {
		returnData = { status: 0, message: 'Please select a file first.', file: 0 };
		return returnData;
	}
	try {
        console.log(file.type);
        // Get signed URL and unique file URL from backend
        const { data } = await axios.get(`${process.env.REACT_APP_API_URL}uploadS3/generate-signed-url`, {
            params: { fileName: file.name, fileType: file.type, uploadType }
        });
        // Upload file to S3 using signed URL
        await axios.put(data.signedUrl, file, {
            headers: {
                "Content-Type": file.type
            }
        });
		returnData = { status: 0, message: 'File uploaded successfully.', file: data.fileUrl ? data.fileUrl : 0 };
		return returnData;
        // setMessage(`File uploaded successfully! File URL: ${data.fileUrl}`);
    } catch (error) {
        console.error("Upload error:", error.message);
        // setMessage("File upload failed.");
		returnData = { status: 0, message: error.message, file: 0 };
    } finally {
        // setUploading(false);
    }
	return returnData;
}

// commons functions

// for the Payment Functions
export async function loadRazorpayScript() {
  return new Promise((resolve) => {
    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });
}
// for the Payment Functions

// Start for for the master data end here like brand colors etc.
export async function CreateMasterData(table, array, editId = '0') {
  let returnData = { status: 0, message: 'Something went wrong, Please try again later.' };
  try {
        const token = localStorage.getItem('aToken');
        const response = await axios.post(
            `${process.env.REACT_APP_API_URL}dynamicCrud`, 
            array,
            {
                headers: {
                    Authorization: `Basic ${token}`,
                    'model-name': table,
                    'edit-id': editId
                },
            }
        );
        const data = response.data;
    returnData = { status: data.status, message: data.message };
    return returnData;
        // setMessage(`File uploaded successfully! File URL: ${data.fileUrl}`);
    } catch (error) {
        consoleLogMst(error.message);
        // setMessage("File upload failed.");
        returnData = { status: 0, message: error.message };
    }
  return returnData;
} 

export async function DeleteMasterData(table, editId = '0') {
  let returnData = { status: 0, message: 'Something went wrong, Please try again later.' };
  try {
        const token = localStorage.getItem('aToken');
        const response = await axios.delete(
            `${process.env.REACT_APP_API_URL}dynamicCrud/delete`, 
            {
                headers: {
                    Authorization: `Basic ${token}`,
                    'model-name': table,
                    'delete-id': editId
                },
            }
        );
        const data = response.data;
    returnData = { status: data.status, message: data.message };
    return returnData;
        // setMessage(`File uploaded successfully! File URL: ${data.fileUrl}`);
    } catch (error) {
        consoleLogMst(error.message);
        // setMessage("File upload failed.");
        returnData = { status: 0, message: error.message };
    }
  return returnData;
}

export async function ListMasterData(table, filters) {
  let returnData = { status: 0, message: 'Something went wrong, Please try again later.', data: [] };
  try {
        const token = localStorage.getItem('aToken');
        const response = await axios.post(
            `${process.env.REACT_APP_API_URL}dynamicCrud/listData`, 
            filters,
            {
                headers: {
                    Authorization: `Basic ${token}`,
                    'model-name': table,
                },
            }
        );
        const data = response.data;
    returnData = { status: data.status, message: data.message, data: data.data };
    return returnData;
        // setMessage(`File uploaded successfully! File URL: ${data.fileUrl}`);
    } catch (error) {
        consoleLogMst(error.message);
        // setMessage("File upload failed.");
        returnData = { status: 0, message: error.message, data: [] };
    }
  return returnData;
} 
// End for for the master data end here like brand colors etc.

// start for the Cars API
export async function CreateCarData(array, editID = '0') {
  let returnData = { status: 0, message: 'Something went wrong, Please try again later.' };
  try {
        const token = localStorage.getItem('aToken');
        const response = await axios.post(
            `${process.env.REACT_APP_API_URL}cars`, 
            array,
            {
                headers: {
                    Authorization: `Basic ${token}`,
                    'edit-id': editID
                },
            }
        );
        const data = response.data;
    returnData = { status: data.status, message: data.message, editID: data.editID ? data.editID : editID };
    return returnData;
        // setMessage(`File uploaded successfully! File URL: ${data.fileUrl}`);
    } catch (error) {
        consoleLogMst(error.message);
        // setMessage("File upload failed.");
        returnData = { status: 0, message: error.message };
    }
  return returnData;
}

export async function ListCarsData(filters) {
  let returnData = { status: 0, message: 'Something went wrong, Please try again later.', data: [] };
  try {
        const token = localStorage.getItem('aToken');
        const response = await axios.post(
            `${process.env.REACT_APP_API_URL}cars/listData`, 
            filters,
            {
                headers: {
                    Authorization: `Basic ${token}`,
                },
            }
        );
        const data = response.data;
    returnData = { status: data.status, message: data.message, data: data.data };
    return returnData;
        // setMessage(`File uploaded successfully! File URL: ${data.fileUrl}`);
    } catch (error) {
        consoleLogMst(error.message);
        // setMessage("File upload failed.");
        returnData = { status: 0, message: error.message, data: [] };
    }
  return returnData;
}

export async function DetailsCarData(filters) {
  let returnData = { status: 0, message: 'Something went wrong, Please try again later.', data: [] };
  try {
        const token = localStorage.getItem('aToken');
        const response = await axios.post(
            `${process.env.REACT_APP_API_URL}cars/detailData`, 
            filters,
            {
                headers: {
                    Authorization: `Basic ${token}`,
                },
            }
        );
        const data = response.data;
    returnData = { status: data.status, message: data.message, data: data.data };
    return returnData;
        // setMessage(`File uploaded successfully! File URL: ${data.fileUrl}`);
    } catch (error) {
        consoleLogMst(error.message);
        // setMessage("File upload failed.");
        returnData = { status: 0, message: error.message, data: [] };
    }
  return returnData;
}
// End for the Cars API

// Start for the User API
export async function checkLoggedIn(filters = {}) {
  let returnData = { status: 0, message: 'Something went wrong, Please try again later.', data: [] };
  try {
        const token = localStorage.getItem('uToken');
        const response = await axios.post(
            `${process.env.REACT_APP_API_URL}user/checkLogin`, 
            filters,
            {
                headers: {
                    Authorization: `Basic ${token}`,
                },
            }
        );
        const data = response.data;
        returnData = { status: data.status, message: data.message, data: data.data };
      return returnData;
    } catch (error) {
        consoleLogMst(error);
        returnData = { status: 0, message: error.message, data: [] };
    }
  return returnData;
  // return false;
}

export async function fetchUserData(filters = {}) {
  let returnData = { status: 0, message: 'Something went wrong, Please try again later.', data: [] };
  try {
        const token = localStorage.getItem('uToken');
        const response = await axios.post(
            `${process.env.REACT_APP_API_URL}user/fetchUserData`, 
            filters,
            {
                headers: {
                    Authorization: `Basic ${token}`,
                },
            }
        );
        const data = response.data;
        returnData = { status: data.status, data: data.data };
      return returnData;
    } catch (error) {
        consoleLogMst(error);
        returnData = { status: 0, data: {} };
    }
  return returnData;
  // return false;
}

export async function checkUserNameAlready(filters = {}) {
  let returnData = { status: 0, message: 'Something went wrong, Please try again later.', data: [], type: '' };
  try {
        const token = localStorage.getItem('uToken');
        const response = await axios.post(
            `${process.env.REACT_APP_API_URL}user/checkUserName`, 
            filters,
            {
                headers: {
                    Authorization: `Basic ${token}`,
                },
            }
        );
        const data = response.data;
        returnData = { status: data.status, message: data.message, type: data.type, data: data.data };
      return returnData;
    } catch (error) {
        consoleLogMst(error);
        returnData = { status: 0, message: error.message, data: [], type: '' };
    }
  return returnData;
  // return false;
}

export async function sendOtpMobile(filters = {}) {
  let returnData = { status: 0, message: 'Something went wrong, Please try again later.', data: [] };
  try {
        const token = localStorage.getItem('uToken');
        const response = await axios.post(
            `${process.env.REACT_APP_API_URL}external/sendOtp`, 
            filters,
            {
                headers: {
                    Authorization: `Basic ${token}`,
                },
            }
        );
        const data = response.data;
        returnData = { status: data.status, message: data.message, data: data.data };
      return returnData;
    } catch (error) {
        consoleLogMst(error);
        returnData = { status: 0, message: error.message, data: [] };
    }
  return returnData;
  // return false;
}

export async function verifyOtpMobile(filters = {}) {
  let returnData = { status: 0, message: 'Something went wrong, Please try again later.', data: [] };
  try {
        const token = localStorage.getItem('uToken');
        const response = await axios.post(
            `${process.env.REACT_APP_API_URL}external/verifyOtp`, 
            filters,
            {
                headers: {
                    Authorization: `Basic ${token}`,
                },
            }
        );
        const data = response.data;
        returnData = { status: data.status, message: data.message, data: data.data };
      return returnData;
    } catch (error) {
        consoleLogMst(error);
        returnData = { status: 0, message: error.message, data: [] };
    }
  return returnData;
  // return false;
}


export async function sendOtpEmail(filters = {}) {
  let returnData = { status: 0, message: 'Something went wrong, Please try again later.', data: [] };
  try {
        const token = localStorage.getItem('uToken');
        const response = await axios.post(
            `${process.env.REACT_APP_API_URL}external/sendOtpEmail`, 
            filters,
            {
                headers: {
                    Authorization: `Basic ${token}`,
                },
            }
        );
        const data = response.data;
        returnData = { status: data.status, message: data.message, data: data.data };
      return returnData;
    } catch (error) {
        consoleLogMst(error);
        returnData = { status: 0, message: error.message, data: [] };
    }
  return returnData;
  // return false;
}

export async function loginToPortal(filters = {}) {
  let returnData = { status: 0, message: 'Something went wrong, Please try again later.', data: [] };
  try {
        const token = localStorage.getItem('uToken');
        const response = await axios.post(
            `${process.env.REACT_APP_API_URL}user/login`, 
            filters,
            {
                headers: {
                    Authorization: `Basic ${token}`,
                },
            }
        );
        const data = response.data;
        returnData = { status: data.status, message: data.message, ...data };
      return returnData;
    } catch (error) {
        consoleLogMst(error);
        returnData = { status: 0, message: error.message };
    }
  return returnData;
  // return false;
}
// End for the User API

// for the Booking 
export async function ListUsersBookings(array) {
  let returnData = { status: 0, message: 'Something went wrong, Please try again later.', data: [], cars: [] };
  try {
        const token = localStorage.getItem('uToken');
        const response = await axios.post(
            `${process.env.REACT_APP_API_URL}bookings/userBooking`, 
            { ...array, nekot: token },
            {
                headers: {
                    Authorization: `Basic ${token}`,
                },
            }
        );
        const data = response.data;
    returnData = { status: data.status, message: data.message, data: data.data, cars: data.cars };
    return returnData;
        // setMessage(`File uploaded successfully! File URL: ${data.fileUrl}`);
    } catch (error) {
        consoleLogMst(error.message);
        // setMessage("File upload failed.");
        returnData = { status: 0, message: error.message, data: [], cars: [] };
    }
  return returnData;
}

export async function UpdateUserProfile(array) {
  let returnData = { status: 0, message: 'Something went wrong, Please try again later.' };
  try {
        const token = localStorage.getItem('uToken');
        const response = await axios.post(
            `${process.env.REACT_APP_API_URL}user/updateUserProfile`, 
            { ...array, nekot: token },
            {
                headers: {
                    Authorization: `Basic ${token}`,
                },
            }
        );
        const data = response.data;
    returnData = { status: data.status, message: data.message };
    return returnData;
        // setMessage(`File uploaded successfully! File URL: ${data.fileUrl}`);
    } catch (error) {
        consoleLogMst(error.message);
        // setMessage("File upload failed.");
        returnData = { status: 0, message: error.message };
    }
  return returnData;
}

// for the contact Enquiries
export async function MakeRequest(array, modelName = "contactUs") {
  let returnData = { status: 0, message: 'Something went wrong, Please try again later.' };
  try {
        const token = getRandomInt(1000, 99999999);
        const response = await axios.post(
            `${process.env.REACT_APP_API_URL}common/doRequest`, 
            { ...array, nekot: token },
            {
                headers: {
                    'token': token,
                    'model-name': modelName,
                },
            }
        );
        const data = response.data;
    returnData = { status: data.status, message: data.message };
    return returnData;
        // setMessage(`File uploaded successfully! File URL: ${data.fileUrl}`);
    } catch (error) {
        consoleLogMst(error.message);
        // setMessage("File upload failed.");
        returnData = { status: 0, message: error.message };
    }
  return returnData;
}
// for the contact Enquiries

export const allFaqsNamo= [
  { 
    question: 'How do I book a self-drive car with Namo Cars?', 
    answer: 'Booking is quick and easy. Simply visit our website, select your preferred car, choose pickup & drop locations, and confirm your booking in just a few clicks.' 
  },
  { 
    question: 'What documents are required for booking?', 
    answer: 'You just need a valid driving license and a government-issued ID proof at the time of booking and pickup.' 
  },
  { 
    question: 'Do you offer multiple pickup locations?', 
    answer: 'Yes, we have several pickup points across the city, so you can choose the most convenient location for your journey.' 
  },
  { 
    question: 'Is fuel included in the booking price?', 
    answer: 'Fuel is generally not included. You will receive the car with a Minimal Level tank and are expected to return it the same way, unless otherwise specified in your booking plan.' 
  },
  { 
    question: 'What if I return the car late?', 
    answer: 'Late returns may attract additional charges depending on the delay. We recommend contacting our support team in advance if you need extra time.' 
  },
  { 
    question: 'Do I need to pay a security deposit?', 
    answer: 'Yes, a refundable security deposit is required at the time of booking. The amount varies by car model and will be returned once the vehicle is checked after drop-off.' 
  },
  { 
    question: 'Are the cars insured?', 
    answer: 'Yes, all our cars are fully insured. However, in case of an accident due to negligence or violation of terms, certain costs may need to be borne by the customer.' 
  },
  { 
    question: 'What is the cancellation policy?', 
    answer: 'You can cancel your booking anytime before the trip starts. Cancellation charges may apply depending on how close the cancellation is to your pickup time.' 
  },
  { 
    question: 'Is there a minimum age requirement for renting?', 
    answer: 'Yes, the minimum age to rent a car with Namo Cars is 21 years, and the driver must hold a valid driving license for at least two years.' 
  },
  { 
    question: 'Can I extend my booking during the trip?', 
    answer: 'Yes, you can extend your booking by contacting our support team or through the app, subject to availability of the vehicle.' 
  },
  { 
    question: 'Do you provide roadside assistance?', 
    answer: 'Yes, we provide 24/7 roadside assistance to ensure your trip is safe and worry-free.' 
  },
  { 
    question: 'Are there any kilometer limits?', 
    answer: 'We offer Various kilometer packages. Details will be available at the time of booking.' 
  },
  { 
    question: 'Can I drive outside the city or state?', 
    answer: 'Yes, but you must inform us at the time of booking. Additional charges or permits may apply depending on the route.' 
  }
];
